import React from 'react';

interface ArticleStatsProps {
  wordCount?: number;
  grade: number;
  lexileLevel: string;
  flexDirection?: 'col' | 'row';
}

const ArticleStats: React.FC<ArticleStatsProps> = ({
  wordCount,
  grade,
  lexileLevel,
  flexDirection = 'col',
}) => {
  return (
    <div
      className={`flex ${flexDirection === 'col' ? 'flex-col space-y-2 items-end' : 'flex-row space-x-2 items-start'} `}
    >
      {wordCount != null && (
        <div
          className="text-gray-700 text-base font-bold whitespace-nowrap justify-center items-stretch bg-gray-200 bg-opacity-60 p-2 rounded-3xl
          max-sm:mt-3
          max-md:pt-1
        "
        >
          {wordCount.toLocaleString()} Words
        </div>
      )}
      <div
        className="text-blue-600 text-base font-bold whitespace-nowrap justify-center items-stretch bg-blue-600 bg-opacity-10 p-2 rounded-3xl
        max-sm:mt-3
        max-md:pt-1
      "
      >
        Grade {grade} - {lexileLevel}
      </div>
    </div>
  );
};

export default ArticleStats;
